module.exports = __webpack_public_path__ + "img/marker-icon-iot.6c35e39a.png";